import clsx from 'clsx';

import { P1 } from 'src/components/Typography';

import { ErrorIconBadge } from '../IconBadge';

export interface Props {
  text: string;
  className?: string;
}

// new-ui
export function ErrorMessage({ text, className }: Props) {
  return (
    <div data-testid='error-message' className={clsx(className, 'row a-center items-p8')}>
      <ErrorIconBadge />
      <P1 title={text} className='t-ellipsis'>
        {text}
      </P1>
    </div>
  );
}
